import {DisclaimerOhio} from "../components/DisclaimerOhio";

export const appTopComponents = (
  <>
    <DisclaimerOhio/>
  </>
);
